import RunSearchSchema, { RunSearch } from '../../schemas/action/RunSearchSchema'
// import ActionSchema from '../../schemas/dispatch/ActionSchema'
import ActionType from '../../enums/action/Type'
// import { QueryData } from '../../utils/queryDataUtil'
import { toExternal } from '../util'

export default function RunSearchVo(service: any, namesMap?: Map<string, string>): RunSearch {
  const state = RunSearchSchema.validateSync({
    service,
    namesMap,
    type: ActionType.RUN_SEARCH
  })

  state.queryData.add('spec', toExternal(service))
  // NOTE: let qs.stringify handle the stringification in csrfUtil.js
  // state.queryData.add('spec', JSON.stringify(toExternal(service)))

  // NOTE: for now we use convertResult() directly instead of initilaized via parent class
  // const parentState = ActionSchema.validateSync({
  // type: ActionType.RUN_SEARCH
  // convertResult: // TODO: converResult.bind()
  // })
  return state
}
